import _regeneratorRuntime from "babel-runtime/regenerator";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp, _initialiseProps;

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
/** @todo use MediaRecorder directly without 3rd party lib */


import MediaStreamRecorder from "msr";
import fixWebmDuration from "./Utils/FixWebmDuration";
import ContextFactory from "../Context";
import { getImageMeta } from "../Misc/Image";
var DEFAULT_STATE = {
  isProcessing: false,
  isRehearsing: false,
  isRecording: false,
  recordingStream: null,
  recordedVideo: null,
  recordedTime: 0,
  script: null,
  scriptTextSize: 36,
  scriptTextColor: "#fff",
  teleprompterSpeed: 1,
  autoStopTimeout: 0,
  isScriptEditorActive: true,
  hideTeleprompter: false,
  showHotspot: false,
  showFrames: false,
  frames: {},
  filterFramesToCurrentResolution: false,
  orientation: "landscape",
  assistScriptGeneration: undefined
};
var IS_BUSY_FLAG = "isBusy";
var FRAMES_PAGE_SIZE = 20;
var interval = void 0;
var AppContext = (_temp = _class = function AppContext(propagateMutation) {
  var _this = this;

  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _extends({}, DEFAULT_STATE);

  _classCallCheck(this, AppContext);

  _initialiseProps.call(this);

  this.state = state;

  this._propagateMutation = function () {
    propagateMutation(_this);
  };
}, _class.mediaConstraints = {
  audio: true,
  video: {
    width: 4096,
    frameRate: {
      ideal: 60,
      min: 10
    },
    facingMode: "user"
  }
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.setState = function (newState) {
    Object.keys(newState).map(function (key) {
      return _this2.state[key] = newState[key];
    });

    _this2._propagateMutation();
  };

  this.initializeState = function (state) {
    _this2.setState(_extends({}, DEFAULT_STATE, state));
  };

  this.setVideoReadyHandler = function (handler) {
    return _this2.setState({
      videoReadyHandler: handler
    });
  };

  this.videoReadyHandler = function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(blob) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this2.state.recordedVideo) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _this2.state.recordingStream.getVideoTracks().forEach(function (track) {
                return track.stop();
              });

              _this2.state.recordingStream.getAudioTracks().forEach(function (track) {
                return track.stop();
              });

              fixWebmDuration(blob, Date.now() - _this2.state.startRecordingTime, function (fixedBlob) {
                _this2.setState({
                  isRecording: false,
                  recordingStream: null,
                  mediaRecorder: null,
                  recordedVideo: fixedBlob
                });
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    return function (_x2) {
      return _ref.apply(this, arguments);
    };
  }();

  this.useRecordedVideo = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _this2.setState({
              isProcessing: true
            });

            _context2.next = 3;
            return _this2.state.videoReadyHandler(_this2.state.recordedVideo);

          case 3:
            _this2.setState({
              isProcessing: false,
              recordedVideo: null
            });

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, _this2);
  }));

  this.setCloseHandler = function (handler) {
    return _this2.closeHandler = function () {
      var _state = _this2.state,
          isRecording = _state.isRecording,
          isProcessing = _state.isProcessing;

      if (!isProcessing && !isRecording) {
        handler();
      }
    };
  };

  this.closeHandler = function () {};

  this.increaseScriptTextSize = function () {
    var scriptTextSize = _this2.state.scriptTextSize + 2;

    _this2.setState({
      scriptTextSize: scriptTextSize
    });
  };

  this.decreaseScriptTextSize = function () {
    var scriptTextSize = _this2.state.scriptTextSize - 2;

    _this2.setState({
      scriptTextSize: Math.max(scriptTextSize, 10)
    });
  };

  this.setScriptTextColor = function (scriptTextColor) {
    return _this2.setState({
      scriptTextColor: scriptTextColor
    });
  };

  this.setTeleprompterSpeed = function (teleprompterSpeed) {
    return _this2.setState({
      teleprompterSpeed: teleprompterSpeed
    });
  };

  this.startRehearsing = function () {
    return _this2.setState({
      isRehearsing: true
    });
  };

  this.stopRehearsing = function () {
    return _this2.setState({
      isRehearsing: false
    });
  };

  this.startExecutionTimer = function (timeout, _handler) {
    _this2.setState({
      executionTimer: {
        timeout: timeout,
        handler: function handler() {
          _handler();

          _this2.setState({
            executionTimer: null
          });
        }
      }
    });
  };

  this.startRecording = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    var _state2, mediaRecorder, startTimeout, stream, _mediaRecorder, handler;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _state2 = _this2.state, mediaRecorder = _state2.mediaRecorder, startTimeout = _state2.startTimeout;

            if (!mediaRecorder) {
              _context3.next = 3;
              break;
            }

            return _context3.abrupt("return");

          case 3:
            _context3.prev = 3;
            _context3.next = 6;
            return navigator.mediaDevices.getUserMedia(AppContext.mediaConstraints);

          case 6:
            stream = _context3.sent;
            _mediaRecorder = new MediaStreamRecorder(stream);
            _mediaRecorder.mimeType = _this2.state.videoMimeType;
            _mediaRecorder.ondataavailable = _this2.videoReadyHandler;

            _this2.setState({
              recordedVideo: null,
              recordingStream: stream,
              mediaRecorder: _mediaRecorder
            });

            handler = function handler() {
              _this2.setState({
                isRecording: true,
                showHotspot: false,
                recordedTime: 0,
                startRecordingTime: Date.now()
              });

              _mediaRecorder.start();

              _this2.startRecordingTimer();
            };

            startTimeout > 0 ? _this2.startExecutionTimer(startTimeout, handler) : handler();
            _context3.next = 18;
            break;

          case 15:
            _context3.prev = 15;
            _context3.t0 = _context3["catch"](3);
            console.error("media error", _context3.t0);

          case 18:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, _this2, [[3, 15]]);
  }));

  this.startRecordingTimer = function () {
    interval = setInterval(function () {
      var recordedTime = _this2.state.recordedTime;

      _this2.setState({
        recordedTime: recordedTime + 1
      });
    }, 1000);
  };

  this.stopRecordingTimer = function () {
    if (!interval) {
      return;
    }

    clearInterval(interval);
    interval = null;
  };

  this.stopRecording = function (timeout) {
    var handler = function handler() {
      _this2.stopRecordingTimer();

      var mediaRecorder = _this2.state.mediaRecorder;

      if (mediaRecorder) {
        mediaRecorder.stop();
      }
    };

    timeout > 0 ? _this2.startExecutionTimer(timeout, handler) : handler();
  };

  this.resetRecordedVideo = function () {
    _this2.setState({
      recordedVideo: null
    });
  };

  this.toggleScriptEditor = function () {
    var isScriptEditorActive = !_this2.state.isScriptEditorActive;

    _this2.setState({
      isScriptEditorActive: isScriptEditorActive
    });

    var scriptText = (_this2.state.script || {}).text;

    if (!isScriptEditorActive && !scriptText) {
      _this2.setState({
        hideTeleprompter: true
      });
    }
  };

  this.setScriptText = function (scriptText) {
    _this2.setState({
      script: _extends({}, _this2.state.script, {
        text: scriptText
      })
    });
  };

  this.toggleTeleprompter = function () {
    var scriptText = (_this2.state.script || {}).text;

    _this2.setState({
      hideTeleprompter: scriptText ? !_this2.state.hideTeleprompter : true
    });
  };

  this.toggleHotspot = function () {
    return _this2.setState({
      showHotspot: !_this2.state.showHotspot
    });
  };

  this.toggleFrames = function () {
    var showFrames = !_this2.state.showFrames;

    _this2.setState({
      showFrames: showFrames
    });

    var onFrameChange = _this2.state.onFrameChange;

    if (onFrameChange) {
      var _state$frames = _this2.state.frames,
          _state$frames$frames = _state$frames.frames,
          loadedFrames = _state$frames$frames === undefined ? [] : _state$frames$frames,
          _state$frames$selecte = _state$frames.selectedFrame,
          selectedFrame = _state$frames$selecte === undefined ? 0 : _state$frames$selecte;
      onFrameChange(showFrames ? loadedFrames[selectedFrame] : null);
    }
  };

  this.frames = {
    _setFramesAttribute: function _setFramesAttribute(attribute, value) {
      var _extends2;

      _this2.setState({
        frames: _extends({}, _this2.state.frames, (_extends2 = {}, _extends2[attribute] = value, _extends2))
      });
    },
    isBusy: function isBusy() {
      return _this2.state.frames[IS_BUSY_FLAG];
    },
    hasFrames: function hasFrames() {
      return !!_this2.state.frames.framesSource;
    },
    loadMoreFrames: function loadMoreFrames() {
      if (_this2.frames.isBusy()) {
        return;
      }

      var _state$frames2 = _this2.state.frames,
          _state$frames2$page = _state$frames2.page,
          page = _state$frames2$page === undefined ? 0 : _state$frames2$page,
          _state$frames2$hasMor = _state$frames2.hasMore,
          hasMore = _state$frames2$hasMor === undefined ? true : _state$frames2$hasMor;

      if (!hasMore) {
        return;
      }

      _this2.frames._setFramesAttribute("page", page + 1);

      _this2.frames.loadFrames();
    },
    getFrames: function getFrames() {
      var _state3 = _this2.state,
          filterFramesToCurrentResolution = _state3.filterFramesToCurrentResolution,
          orientation = _state3.orientation,
          frames = _state3.frames;

      if (!filterFramesToCurrentResolution) {
        return frames;
      }

      var _frames$frames = frames.frames,
          loadedFrames = _frames$frames === undefined ? [] : _frames$frames;
      return _extends({}, frames, {
        frames: loadedFrames.filter(function (frame) {
          return frame.orientation === orientation;
        })
      });
    },
    selectFrame: function selectFrame(frameNumber) {
      _this2.frames._setFramesAttribute("selectedFrame", frameNumber);

      var _state$frames$frames2 = _this2.state.frames.frames,
          frames = _state$frames$frames2 === undefined ? [] : _state$frames$frames2;

      if (frames.length - frameNumber <= 5) {
        _this2.frames.loadMoreFrames();
      }

      var onFrameChange = _this2.state.onFrameChange;

      if (onFrameChange) {
        onFrameChange(frames[frameNumber]);
      }
    },
    loadFrames: function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var _state$frames3, selectedFrame, framesSource, _state$frames3$page, page, _state$frames3$frames, frames, rest, loadedFrames, measuredFrames;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _state$frames3 = _this2.state.frames, selectedFrame = _state$frames3.selectedFrame, framesSource = _state$frames3.framesSource, _state$frames3$page = _state$frames3.page, page = _state$frames3$page === undefined ? 0 : _state$frames3$page, _state$frames3$frames = _state$frames3.frames, frames = _state$frames3$frames === undefined ? [] : _state$frames3$frames, rest = _objectWithoutProperties(_state$frames3, ["selectedFrame", "framesSource", "page", "frames"]);

                if (!(!framesSource || rest[IS_BUSY_FLAG])) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return");

              case 3:
                _this2.frames._setFramesAttribute(IS_BUSY_FLAG, true);

                _context5.next = 6;
                return framesSource(page * FRAMES_PAGE_SIZE, FRAMES_PAGE_SIZE);

              case 6:
                loadedFrames = _context5.sent;
                _context5.next = 9;
                return Promise.all(loadedFrames.map(function () {
                  var _ref5 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee4(frame) {
                    var _ref6, width, height;

                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.prev = 0;
                            _context4.next = 3;
                            return getImageMeta(frame.url);

                          case 3:
                            _ref6 = _context4.sent;
                            width = _ref6.width;
                            height = _ref6.height;
                            return _context4.abrupt("return", _extends({
                              orientation: width >= height ? "landscape" : "portrait"
                            }, frame));

                          case 9:
                            _context4.prev = 9;
                            _context4.t0 = _context4["catch"](0);
                            return _context4.abrupt("return", null);

                          case 12:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this2, [[0, 9]]);
                  }));

                  return function (_x3) {
                    return _ref5.apply(this, arguments);
                  };
                }()));

              case 9:
                measuredFrames = _context5.sent;

                if (typeof selectedFrame === "undefined") {
                  _this2.frames._setFramesAttribute("selectedFrame", 0);
                }

                _this2.frames._setFramesAttribute("frames", frames.concat(measuredFrames.filter(function (val) {
                  return !!val;
                })));

                _this2.frames._setFramesAttribute("hasMore", loadedFrames.length >= FRAMES_PAGE_SIZE);

                _this2.frames._setFramesAttribute(IS_BUSY_FLAG, false);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this2);
      }));

      return function loadFrames() {
        return _ref4.apply(this, arguments);
      };
    }()
  };

  this.setOrientation = function (orientation) {
    if (_this2.state.orientation === orientation) {
      return;
    }

    if (_this2.state.filterFramesToCurrentResolution) {
      _this2.frames.selectFrame(0);
    }

    _this2.setState({
      orientation: orientation
    });
  };
}, _temp);

var _ContextFactory = ContextFactory(AppContext),
    withProvider = _ContextFactory.withProvider,
    consumeContext = _ContextFactory.consumeContext;

export { withProvider, consumeContext };